import ErrorFallback from 'components/core/ErrorFallback';
import FuncNavBar from 'components/funcionario/FuncNavbar';
import DoctorNavBar from 'pages/doctor/NavBar';
import PatientNavBar from 'pages/paciente/NavBar';
import { Container } from 'react-bootstrap';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { selectDoctor, selectFunc, selectPatient } from 'redux/features/auth/authSlice';

export default function UnifiedLayout({ children }) {
  const patient = useSelector(selectPatient);
  const doctor = useSelector(selectDoctor);
  const func = useSelector(selectFunc);

  if (!patient && !doctor && !func) {
    return (
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, errorInfo) => {
          console.error('ErrorBoundary (UnifiedLayout) capturou um erro:', error, errorInfo);
        }}
      >
        {children}
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        console.error('ErrorBoundary (UnifiedLayout) capturou um erro:', error, errorInfo);
      }}
    >
      <Container fluid className="px-0">
        {!!doctor && <DoctorNavBar />}
        {!!patient && <PatientNavBar />}
        {!!func && <FuncNavBar />}
        {children}
      </Container>
    </ErrorBoundary>
  );
}
